import firebase from "firebase/app";
import "firebase/auth";

export const auth = firebase.initializeApp({
    apiKey: "AIzaSyC9vFew9Em1qashndtHC2eH6wEU8m6C9CU",
    authDomain: "unichat-82e0a.firebaseapp.com",
    projectId: "unichat-82e0a",
    storageBucket: "unichat-82e0a.appspot.com",
    messagingSenderId: "813064082069",
    appId: "1:813064082069:web:6316ff2de50ae490be419c"
  }).auth();